import { NotificationConfiguration } from '../notification.templates';

export const SHARE_MEETING_MINUTES_TEMPLATE: NotificationConfiguration = {
  inapp: `<b>{triggeredByName}</b> shared meeting minutes with you.`,
  email: {
    ctaKey: 'go_to_meeting_minutes',
  },
};
